import { render, staticRenderFns } from "./CarouselSlide.vue?vue&type=template&id=c9059f0c&scoped=true&"
import script from "./CarouselSlide.vue?vue&type=script&lang=js&"
export * from "./CarouselSlide.vue?vue&type=script&lang=js&"
import style0 from "./CarouselSlide.vue?vue&type=style&index=0&id=c9059f0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9059f0c",
  null
  
)

export default component.exports